import { useQuery } from '@apollo/client';
import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import type { UseFetchDealIdGroupInfoParams } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import { GetDealGroupInfoDocument } from '../../../graphql/query/deals/GetDealGroupInfo.generated.tsx';

export const useFetchDealIdGroupInfo: DealProviderConfig['useFetchDealIdGroupInfo'] = ({
  dealIds,
}: UseFetchDealIdGroupInfoParams) => {
  const { data } = useQuery(GetDealGroupInfoDocument, {
    nextFetchPolicy: 'cache-only',
    skip: !dealIds?.length,
    variables: {
      deal_ids: dealIds,
    },
  });

  const { dealGroupInfo } = data || {};

  return {
    dealGroupInfo: dealGroupInfo ?? [],
  };
};
